import { render, staticRenderFns } from "./BtnBgVideo.vue?vue&type=template&id=42a1b30f&"
import script from "./BtnBgVideo.vue?vue&type=script&lang=js&"
export * from "./BtnBgVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports